import { render, staticRenderFns } from "./AddressBookIconButton.vue?vue&type=template&id=f27e02f2&scoped=true"
import script from "./AddressBookIconButton.vue?vue&type=script&lang=ts"
export * from "./AddressBookIconButton.vue?vue&type=script&lang=ts"
import style0 from "./AddressBookIconButton.vue?vue&type=style&index=0&id=f27e02f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27e02f2",
  null
  
)

export default component.exports